import { SVGProps } from './types';

const EditIcon01 = (props: SVGProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      fill="none"
      viewBox="0 0 20 20"
      {...props}
    >
      <path
        stroke="currentColor"
        strokeLinejoin="round"
        strokeWidth="1.2"
        d="M9.98 5l5.012 5"
      />
      <path
        stroke="currentColor"
        strokeWidth="1.08"
        d="M2.5 13.006L12.97 2.503a.012.012 0 01.017 0L17.49 7a.008.008 0 010 .01L6.993 17.5H2.5v-4.494z"
      />
    </svg>
  );
};

export { EditIcon01 };
